export const FIND_TARGET_ACTUALS_FAILURE = 'FIND_TARGET_ACTUALS_FAILURE';

export const findTargetActualsFailure = ({ error, request }) => ({
    type: FIND_TARGET_ACTUALS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});